import { useState } from "react";
import BglHourly from "../BglHourly";
import BglBooklet from "../BglBooklet";


export type HourlyProps = {
  toggleHourly:() => void,
};

const BglForm = () => 
{
  const [hourly, setHourly] = useState(false);

  const toggleHourly = () =>
  {
    setHourly(!hourly);
  }

  if(hourly)
    return (<BglHourly toggleHourly={toggleHourly} />);
  
  return (
    <BglBooklet toggleHourly={toggleHourly}/>
  ) 
}

export default BglForm;